
import Sun from "../../../assets/duotone/Sun.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SunIcon({ className, dataTestid = "SunIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Sun data-testid={dataTestid} className={classes} {...rest} />
  );
}
